import * as __federation__ from "virtual:__federation__";

/**
 * Load a remote module dynamically
 * @param url Example: "http://localhost:5002/assets/remoteEntry.js"
 * @param name Example: "mfe2"
 * @param module Example: "./AppRoot"
 * @param from Whether the remote module is built with Vite or Webpack
 * @param format The format of the remote module. Example: "var", "esm", etc.
 * @returns
 */
export async function loadDynamicRemote<T>(
	url: string,
	name: string,
	module: string,
	from: "vite" | "webpack" = "vite",
	format: "esm" | "systemjs" | "var" = "esm"
): Promise<T> {
	__federation__.__federation_method_setRemote(name, {
		url: () => Promise.resolve(url),
		format: format,
		from: from,
	});

	return (await __federation__.__federation_method_getRemote(name, module)) as T;
}
